export const userProfile = function (object) {
  let constraints = {
    first_name: {
      presence: true,
      length: {
        maximum: 20,
      },
    },
    last_name: {
      presence: true,
      length: {
        maximum: 20,
      },
    },
    email: {
      presence: true,
      email: {
        message: "^Email is not valid",
      },
    },
  };

  const countyValidation = {
    county: {
      presence: {
        allowEmpty: false,
        message: "^County can't be blank",
      },
    },
  };

  const imcValidaiton = {
    imc: {
      presence: {
        allowEmpty: false,
        message: "^IMC Number can't  be blank",
      },
    },
  };

  const pinNumberValidation = {
    pin_number: {
      presence: {
        allowEmpty: false,
        message: "^NMBI PIN Number can't  be blank",
      },
    },
  };

  const practiceNameValidaiton = {
    practice_name: {
      presence: {
        allowEmpty: false,
      },
      length: {
        maximum: 50,
      },
    },
  };

  const hospitalValidation = {
    hospital: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  const registrationValidation = {
    registration: {
      presence: {
        allowEmpty: false,
        message: "^Accreditation Number can't  be blank",
      },
    },
  };

  const professionValidaiton = {
    profession: {
      presence: {
        allowEmpty: false,
        message: "^Profession can't  be blank",
      },
    },
  };

  let roleValidations = {};
  switch (object.user_type) {
    case "gp":
      roleValidations = {
        ...practiceNameValidaiton,
        ...(object.accreditation ? countyValidation : {}),
      };
      break;
    case "gp_trainee":
      roleValidations = { ...practiceNameValidaiton };
      break;
    case "consultant":
      roleValidations = { ...hospitalValidation };
      break;
    // case 'hospital_doctor':
    //   roleValidations = { ...imcValidaiton }
    //break;
    case "practice_nurse":
      roleValidations = { ...registrationValidation, ...pinNumberValidation };
      break;
    case "nurse_specialist":
      roleValidations = { ...registrationValidation, ...pinNumberValidation };
      break;
    case "midwifery":
      roleValidations = { ...registrationValidation, ...pinNumberValidation };
      break;
    case "registered_general_nurses":
      roleValidations = { ...registrationValidation, ...pinNumberValidation };
      break;
    case "allied_healthcare_professional":
      roleValidations = {
        ...registrationValidation,
        ...professionValidaiton,
        ...practiceNameValidaiton,
      };
      break;
    case "industry":
      roleValidations = {
        company_name: {
          presence: {
            allowEmpty: false,
            message: "^Company name can't be blank",
          },
        },
        position: {
          presence: {
            allowEmpty: false,
            message: "^Position/role in the company can't be blank",
          },
        },
      };
      break;
  }
  return { ...constraints, ...roleValidations };
};



// WEBPACK FOOTER //
// ./src/validators/userProfile.js